import { render, staticRenderFns } from "./yourStoresTab.vue?vue&type=template&id=4d51c00a&"
import script from "./yourStoresTab.vue?vue&type=script&lang=js&"
export * from "./yourStoresTab.vue?vue&type=script&lang=js&"
import style0 from "./yourStoresTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports